// @flow

import React, { type Node } from 'react';

import { type PaymentSpec } from './types';
import { PaymentSpecContext } from './context';

type Props = {|
  +spec: PaymentSpec,
  +children: Node,
|};

export function PaymentSpecProvider({ spec, children }: Props): Node {
  return (
    <PaymentSpecContext.Provider value={spec}>
      {children}
    </PaymentSpecContext.Provider>
  );
}
